module.exports = __webpack_public_path__ + "static/media/answer-c-pressed.074dc605.png";